import React, { useState, useEffect } from "react";
import axios from "axios";
import AddAddress from "./addAddress";
import {jwtDecode} from "jwt-decode";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';

const Address = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null); // To store the address being edited
  const [loading, setLoading] = useState(true); // Loading state
  const token = localStorage.getItem("STITCHD_ID");

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        if (token) {
          const decoded = jwtDecode(token);
          const userId = decoded._id;

          const response = await axios.get(
            `${process.env.REACT_APP_URL}/address/user/${userId}`,{
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.success) {
            setAddresses(response.data.data);
          }
        }
      } catch (error) {
        console.error("Error fetching addresses:", error);
      } finally {
        setLoading(false); // Set loading to false after the request is completed
      }
    };

    fetchAddresses();
  }, [token , isModalOpen]);

  const openModal = () => {
    setIsModalOpen(true);
    setSelectedAddress(null); // Clear selected address when opening modal
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async (addressId) => {
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_URL}/address/delete/${addressId}`
      );
      if (response.data.success) {
        // Filter out the deleted address from the addresses state
        setAddresses(addresses.filter((address) => address._id !== addressId));
      }
    } catch (error) {
      console.error("Error deleting address:", error);
    }
  };

  const handleEdit = (address) => {
    setSelectedAddress(address);
    setIsModalOpen(true);
  };

  return (
    <div className="md:mt-28 mt-16 md:ml-20 mx-4">
      <div className="flex justify-between items-center md:flex-row">
        <p className="text-2xl font-semibold font-sans mb-4 md:mb-2 md:text-left text-center mt-2">
          My Addresses
        </p>
        <button
          onClick={openModal}
          className="text-red-500 md:text-sm md:font-semibold text-xs flex items-center md:ml-60"
        >
          <span className="bg-red-500 text-white p-1 px-2 rounded-full mr-2">
            +
          </span>
          ADD NEW ADDRESS
        </button>
      </div>

      {loading ? (
        <div>
          {[...Array(3)].map((_, index) => (
            <div key={index} className="p-4 bg-white rounded-lg shadow-md font-twentieth-century w-full md:w-auto mb-4">
              <Skeleton width="60%" height={20} />
              <Skeleton width="40%" height={20} className="mb-2" />
              <Skeleton width="80%" height={20} className="mb-1" />
              <Skeleton width="80%" height={20} />
            </div>
          ))}
        </div>
      ): addresses.length === 0 ? (
        <p className="col-span-2 md:col-span-3 text-center text-gray-500 text-3xl md:text-5xl p-2 font-twentieth-century">There are no address in your address list!</p>
      ) : (
        addresses.map((address) => (
          <div
            key={address._id}
            className="p-4 bg-white rounded-lg shadow-md font-twentieth-century w-full md:w-auto mb-4"
          >
            <div className="mb-4 flex justify-between items-center">
              <p className="text-gray-700 font-semibold">{address.name}</p>
              <div className="flex space-x-2 md:ml-96">
                <button
                  onClick={() => handleEdit(address)}
                  className="text-gray-400 px-3 py-1 hover:text-gray-600"
                >
                  Edit
                </button>
                <span className="text-gray-400 mt-1">|</span>
                <button
                  onClick={() => handleDelete(address._id)}
                  className="text-red-400 px-3 py-1 hover:text-red-600"
                >
                  Remove
                </button>
              </div>
            </div>
            <div className="mb-4">
              <p className="text-gray-700 text-lg md:w-80 w-full">
                {address.address} , {address.landmark}
              </p>
              <p className="text-gray-700 text-lg md:w-80 w-full">
                {address.city} - {address.postalCode}
              </p>
            </div>
            <div className="mb-4 flex font-semibold">
              <p className="text-lg">Mobile:</p>
              <p className="text-gray-700 ml-2 mt-0.5">+91 {address.phone}</p>
            </div>
          </div>
        ))
      )}

      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-y-auto">
          <div className="w-auto p-2 border bg-gray-200 rounded-md ">
            <div className="p-6">
              <div className="flex justify-end mt-10">
                <button
                  onClick={closeModal}
                  className="text-black hover:text-gray-900 text-lg font-bold"
                >
                  X
                </button>
              </div>
              <AddAddress
                addressToEdit={selectedAddress} // Pass the selected address to AddAddress for editing
                closeModal={closeModal}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Address;
